import { Box, Paper, Skeleton, Typography } from "@mui/material";
import {
    KPI_CAPTION_SX,
    KPI_ERROR_SX,
    KPI_LABEL_SX,
    KPI_STAT_CARD_SX,
    KPI_VALUE_SKELETON_SX,
    KPI_VALUE_SX,
} from "./kpiCardStyles";

interface KpiStatCardProps {
    label: string;
    value: string | number | null;
    caption?: string;
    loading?: boolean;
    error?: boolean;
}

export const KpiStatCard = ({ label, value, caption, loading = false, error = false }: KpiStatCardProps) => {
    const displayValue = typeof value === "number" ? value.toLocaleString() : value;

    return (
        <Paper sx={KPI_STAT_CARD_SX}>
            {error ? (
                <Box sx={KPI_ERROR_SX}>
                    <Typography variant="body2" color="error" align="center">
                        Unable to load data
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography variant="overline" sx={KPI_LABEL_SX}>
                        {label}
                    </Typography>
                    {loading ? (
                        <Skeleton variant="rounded" sx={KPI_VALUE_SKELETON_SX} />
                    ) : (
                        <Typography variant="h3" sx={KPI_VALUE_SX}>
                            {displayValue}
                        </Typography>
                    )}
                    {caption && (
                        <Typography variant="caption" sx={KPI_CAPTION_SX}>
                            {caption}
                        </Typography>
                    )}
                </>
            )}
        </Paper>
    );
};
